<template>
  <vs-table
    :multiple="multiple"
    no-data-text="No tienes conceptos presupuestarios"
    v-model="budgetConceptsSelected"
    :data="budgetConcepts"
    class="table"
  >
    <template slot="thead">
      <vs-th>Concepto Presupuestario</vs-th>
      <vs-th>Monto ($)</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
        <vs-td :data="data[indextr].budgetConcept">
          {{ tr.budgetConcept.label }}
        </vs-td>
        <vs-td :data="data[indextr]">
          {{ tr.amount | amount }}
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
<script>
export default {
  data() {
    return {
      budgetConceptsSelected: this.value || []
    };
  },
  watch: {
    budgetConceptsSelected() {
      this.$emit('input', this.budgetConceptsSelected);
    },
    value(newValue) {
      this.budgetConceptsSelected = newValue;
    }
  },
  props: {
    budgetConcepts: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>
